import { render, staticRenderFns } from "./AboutUsHonor.vue?vue&type=template&id=6fe570aa"
import script from "./AboutUsHonor.vue?vue&type=script&lang=js"
export * from "./AboutUsHonor.vue?vue&type=script&lang=js"
import style0 from "./AboutUsHonor.vue?vue&type=style&index=0&id=6fe570aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports